import React from "react";
import { SAMPLE_REPORTS } from "./accountRules";

// Links to the sample reports (real reports with the home's numbers hidden), so anyone can see
// what full access gets them before paying. only picks which to show.
const NAMES = {buy:"buyer's report", rent:"renter's report", area:'area report'};
const SampleLinks = ({only = ['buy', 'rent', 'area'], lead = 'See a sample', className = 'sample-links'}) => (
    <p className={className}>{lead}{' '}
        {only.map((k, i) => <React.Fragment key={k}>
            {i > 0 && (i === only.length - 1 ? ' or ' : ', ')}
            <a href={SAMPLE_REPORTS[k]} target="_blank" rel="noopener">{NAMES[k]}</a>
        </React.Fragment>)}
        <span className="sample-pdf"> (PDF)</span>
    </p>
);

export default SampleLinks;
